import ApiService from "@/core/services/api.service";
import { getToken } from "@/core/services/jwt.service.js";

export const GetQuotation = (uuid) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.get(`quotation/${uuid}`)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const DeleteService = (uuid) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.delete(`quotation/${uuid}`)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const UpdateChangePrice = (uuid) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.put(`price-update/quotation/${uuid}`)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const CreateQuotation = (params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.post("quotation", params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};

export const UpdateQuotation = (uuid, params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.post(`quotation/${uuid}`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
// http://127.0.0.1:8000/api/v1/quotation/85749367-1a47-4949-872f-40bbba8d13d0/main-to-tempitems
export const GetTempLineItems = (uuid, params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.post(`quotation/${uuid}/main-to-tempitems`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};

export const GetLineItem = (params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.query(`line-item-options-quotation`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const SearchLineItem = (params) => {
	return new Promise((resolve, reject) => {
		console.log("params", params);
		ApiService.setHeader();
		ApiService.query(`line-item`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
/* http://127.0.0.1:8000/api/v1/export-line-items/quotation/a2d04f02-8c50-4301-99bb-6fe1ca0a1ebb */
export const ExportLineItem = (uuid) => {
	return new Promise((resolve, reject) => {
		const token = getToken();
		const api_url = process.env.VUE_APP_API_URL;
		const file_url = `${api_url}export-line-items/quotation/${uuid}?token=${token}`;
		const pdf = window.open(file_url, "_blank");
		if (pdf) {
			resolve(true);
		} else {
			reject(false);
		}
	});
};
/* export const DownloadPDF = ({ url, uuid }) => {
	return new Promise((resolve, reject) => {
		const token = getToken();
		const api_url = process.env.VUE_APP_API_URL;
		const pdf_url = `${api_url}${url}${uuid}?token=${token}`;
		const pdf = window.open(pdf_url, "_blank");
		if (pdf) {
			resolve(true);
		} else {
			reject(false);
		}
	});
}; */
export const UpdateOrCreateLineItems = (url, params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.patch(url, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const DeleteLineItem = (params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.patch(`line-item/delete/single`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const DeleteAllLineItems = (payload) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		/* http://127.0.0.1:8000/api/v1/line-item/delete/all */
		ApiService.put(`line-item/delete/all`, payload)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const ImportLineItems = (params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.upload(`line-item/import`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const GetCustomer = (params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.query(`quotation/get-options`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};

export const getQuotationLineItemByQuotation = (params) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.query(`quotation/get-options`, params)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const GetLocalData = (uuid) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.get(`line-item/previous-temp-items/${uuid}`)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
export const GETLINEITEMSSAMPLE = (type) => {
	return new Promise((resolve, reject) => {
		ApiService.setHeader();
		ApiService.get(`export/line-items/quotation?type=${type}`)
			.then(({ data }) => {
				resolve(data);
			})
			.catch(({ response }) => {
				reject(response);
			});
	});
};
